<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : sapBaseRouteVO.pkid ? '编辑' : '新建'"
      width="1200px"
      class="adaptationModal"
      @close="$reset('form')"
  >
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="sapBaseRouteVO"
        :rules="ruleValidate"
        class="form"
        :disabled="disabled"
        label-width="80px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col :span="9">
          <el-form-item label="物料编号" prop="materialNo">
            <span>{{sapBaseRouteVO.matnr}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item label="物料名称" prop="materialName">
            <span>{{sapBaseRouteVO.maktx}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="规格型号" prop="materialName">
            <span>{{sapBaseRouteVO.specification}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item label="创建时间" prop="addTime">
            <span>{{sapBaseRouteVO.addTime}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="更新时间" prop="updateTime">
            <span>{{sapBaseRouteVO.updateTime}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">工序信息</div>
      <Table border :columns="columns" :data="sapBaseRouteVO.routeList">
        <template slot="keyRoute" slot-scope="{ row, index }">
          <el-switch
              v-model="row.keyRoute"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              @change="change(index,row)"/>
        </template>
        <template slot="checkNum" slot-scope="{ row, index }">
          <el-input-number
              v-model="row.checkNum"
              :max="100"
              :min="0"
              :disabled="row.keyRoute===true"
              @change="change(index,row)"/>
        </template>
      </Table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    components: {},
    data() {
      return {
        disabled: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        sapBaseRouteVO: {
          pkid: 0,
          matnr: "",
          werks: "",
          datuv: "",
          validTo:"",
          addTime:"",
          updateTime:"",
          maktx:"",
          specification:"",
          routeList: [],
        },
        ruleValidate: {
        },
        columns: [
          {
            title: "工作中心",
            key: "arbpl",
            width: 100,
            align: "center",
          },
          {
            title: "基本数量",
            key: "bmsch",
            width: 70,
            align: "center",
          },
          {
            title: "标准文本码",
            key: "ktsch",
            width: 160,
            align: "center",
          },
          {
            title: "节点",
            key: "plnkn",
            width: 70,
            align: "center",
          },
          {
            title: "工序短文本",
            key: "ltxa1",
            width: 160,
            align: "center",
          },
          {
            title: "关键工序",
            slot: "keyRoute",
            width: 100,
            align: "center",
          },
          {
            title: "校验比例",
            slot: "checkNum",
            width: 140,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open(row, mark) {
        console.log(row, mark);
        this.dialogVisible = true;
        this.disabled = mark;
        if (row) {
          this.getRouteInfoByMaterialNo(row.matnr);
        }
      },


      getRouteInfoByMaterialNo(materialNo) {
        this.contentLoading = true;
        this.$http
          .get("basic", `sapBaseRoutes/${materialNo}`)
          .then((resp) => {
            if (resp.success) {
              this.sapBaseRouteVO =  resp.data;
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      handleSubmit() {
        this.submitLoading = true;
        this.$http.put("basic", "sapBaseRoutes", this.sapBaseRouteVO)
          .then((resp) => {
            if (resp.success) {
              this.$message.success("保存成功");
            }
          }).catch((e) => {
            this.$message.error(e);
          }).finally(() => {
            this.submitLoading = false;
            this.dialogVisible=false;
          });
      },

      change(index,row) {
        this.$set(this.sapBaseRouteVO.routeList,index,row);
      },
    },
  };
</script>
